import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@f-fertighaus/widgets/FloatingBanner'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { getUrl } from '@js/common/getUrlByDomain'
import User from '@js/common/user'

import Modal from '@f/components/Modal'

import BudgetCalculatorModal from '@f-fertighaus/applications/BudgetCalculatorModal'
import { FinanceEntryPanel } from '@f-fertighaus/applications/FinanceEntry'
import RegionalPricesInfo from '@f-fertighaus/applications/RegionalPricesInfo'
import SearchResults from '@f-fertighaus/applications/SearchResults'
import { SetLocationModal } from '@f-fertighaus/applications/SearchResults/partials/items/SetLocationModal'

void (function () {
  const SearchResultsPage = props => {
    const openSetLocationModal = () => {
      const modal = new Modal()
      modal.openModal({
        component: <SetLocationModal />
      })
    }

    const openBauortModal = () => {
      const modal = new Modal()
      modal.openModal({
        component: <RegionalPricesInfo />
      })
    }

    const openBudgetOptions = event => {
      event && event.preventDefault()

      const modal = new Modal()

      const openFlow = flowType => {
        let nextModal = new Modal()

        if (flowType === 'budget_calculator') {
          nextModal.openModal({
            component: (
              <BudgetCalculatorModal {...props.sherlock.BudgetCalculator} />
            )
          })
        }
      }

      modal.openModal({
        component: <FinanceEntryPanel openFlow={openFlow} />,
        options: {
          className: 'ModalFinance'
        }
      })
    }

    let availableFilters = []
    if (props.pagetype === 'house-list') {
      availableFilters = [
        {
          name: 'price',
          label: 'Preis',
          type: 'price',
          values: {
            ...props.sherlock.houseFilter.defaultPrice,
            max: 500000
          },
          suffix: '€',
          default: 'price',
          feature: {
            label: 'Budgethilfe',
            target: openBudgetOptions,
            wtData: {
              'CTA-click': {
                label: 'modal-finance-options',
                location: 'filter-panel'
              }
            }
          }
        },
        {
          name: 'delivery_regions',
          label: 'Bauort',
          type: 'bauort',
          info:
            'Wir empfehlen Ihnen den Bauort für verbesserte Preisangaben einzutragen, da diese sich je nach Umgebung unterscheiden.',
          feature: !User.getLocation().postcode
            ? {
                label: 'Genauere Preisangaben erhalten',
                target: openBauortModal,
                wtData: {
                  'CTA-click': {
                    label: 'modal-bauort-regional',
                    location: 'filter-panel'
                  }
                }
              }
            : null
        },
        {
          name: 'expansion_stage',
          label: 'Ausbaustufe',
          type: 'radio',
          default: 'price',
          values: props.sherlock.houseFilter.defaultExpansionStages,
          info:
            'Zustand eines Hauses bei der Übergabe an den Bauherren. Sie hat daher Auswirkung auf den Hauspreis.'
        },
        {
          name: 'construction_method',
          label: 'Bauweise',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultConstructionMethods,
          info:
            'Die Bauweise beschreibt, in welcher Konstruktion und auf welche Weise das Eigenheim errichtet wird.'
        },
        {
          name: 'living_area_total',
          label: 'Wohnfläche',
          type: 'range',
          values: props.sherlock.houseFilter.defaultLivingArea,
          suffix: 'm²'
        },
        {
          name: 'number_rooms',
          label: 'Zimmeranzahl',
          type: 'range',
          values: props.sherlock.houseFilter.defaultRooms,
          labelSuffix: 'Zimmer'
        },
        {
          name: 'form',
          label: 'Haustyp',
          labelPlural: 'Haustypen',
          type: 'checkbox',
          values: [
            { id: 2, name: 'Satteldach-Klassiker' },
            { id: 1, name: 'Bungalow' },
            { id: 4, name: 'Stadtvilla' },
            { id: 3, name: 'Blockhaus' },
            { id: 7, name: 'Fachwerk' },
            { id: 5, name: 'Cubushaus' },
            { id: 6, name: 'Pultdachhaus' }
          ]
        },
        {
          name: 'roof_shape',
          label: 'Dachform',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultRoofShapes
        },
        {
          name: 'styles',
          label: 'Stil',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultStyles
        },
        {
          name: 'utilization',
          label: 'Hausart',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultUtilization
        },
        {
          name: 'energy_standards',
          label: 'Energiestandard',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultEnergyStandards,
          info: 'Je besser die Dämmung, desto besser ist der Energiestandard.'
        },
        {
          name: 'funding',
          label: 'Förderung',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultFunding
        },
        {
          name: 'number_storeys',
          label: 'Etagen',
          type: 'range',
          values: props.sherlock.houseFilter.defaultFloors,
          labelSuffix: 'Etagen'
        },
        {
          name: 'target_groups',
          label: 'Besondere Anforderungen',
          type: 'checkbox',
          values: props.sherlock.houseFilter.defaultTargetGroups
        },
        {
          name: 'vendor_nid',
          label: 'Anbieter',
          type: 'select',
          values: props.sherlock.houseFilter.defaultVendors,
          default: 'Anbieter auswählen'
        },
        {
          name: 'has_floor_plans',
          label: 'Grundrisse',
          type: 'boolean',
          iconName: 'floor-plan-rectangle-14px',
          tracking: {
            on: 'house-list-floor-plan-view',
            off: 'house-list-house-view'
          }
        }
      ]
    }
    if (props.pagetype === 'vendor-list') {
      availableFilters = [
        {
          name: 'vendor',
          label: 'Direkt zum Anbieter',
          type: 'vendor-direct',
          values: props.sherlock.vendorFilter.defaultVendors,
          default: 'Anbieter auswählen'
        },
        {
          name: 'delivery_regions',
          label: 'Bauort',
          type: 'bauort',
          info:
            'Zeigt alle Anbieter, die in Ihrem Gebiet (+50km Umgebung) bauen.'
        },
        {
          name: 'utilization',
          label: 'Hausart',
          labelPlural: 'Verwendungen',
          type: 'checkbox',
          values: props.sherlock.vendorFilter.defaultUtilization
        },
        {
          name: 'construction_method',
          label: 'Bauweise',
          labelPlural: 'Bauweisen',
          type: 'checkbox',
          values: props.sherlock.vendorFilter.defaultConstructionMethods,
          info:
            'Die Bauweise beschreibt, in welcher Konstruktion und auf welche Weise das Eigenheim errichtet wird.'
        },
        {
          name: 'expansion_stage',
          label: 'Ausbaustufe',
          type: 'radio',
          default: 'price',
          values: props.sherlock.vendorFilter.defaultExpansionStages,
          info:
            'Zustand eines Hauses bei der Übergabe an den Bauherren. Sie hat daher Auswirkung auf den Hauspreis.'
        }
      ]
    }

    let availableSorting = []

    if (props.pagetype === 'house-list') {
      availableSorting = [
        {
          label: 'Standard Sortierung',
          value: '',
          isDefault: true
        },
        {
          label: 'Wohnfläche aufsteigend',
          value: 'living_area_total'
        },
        {
          label: 'Wohnfläche absteigend',
          value: '-living_area_total'
        },
        {
          label: 'Preis aufsteigend',
          value: 'price'
        },
        {
          label: 'Preis absteigend',
          value: '-price'
        }
      ]
    }

    let hash = window.location.hash.substring(1)
    if (hash === 'budget-calc') {
      setTimeout(() => {
        const modal = new Modal()

        modal.openModal({
          component: (
            <BudgetCalculatorModal {...props.sherlock.BudgetCalculator} />
          )
        })
      }, 1000)
    } else if (hash === 'budgethilfe') {
      setTimeout(() => {
        openBudgetOptions()
      }, 1000)
    } else if (hash === 'finance') {
      window.location.href = getUrl('financeAssistance')()
    }

    const initialParams = {}
    let searchParams = window.location.search
    if (searchParams) {
      searchParams = searchParams.replace('?', '')
      searchParams = searchParams.split('&')

      searchParams.map(paramSet => {
        let paramSetArray = paramSet.split('=')
        initialParams[paramSetArray[0]] = paramSetArray[1]
      })
    }

    return (
      <SearchResults
        type={props.pagetype === 'vendor-list' ? 'vendors' : 'houses'}
        availableFilters={availableFilters}
        availableSorting={availableSorting}
        initialParams={initialParams}
        openSetLocationModal={openSetLocationModal}
        isSearchResultsPage
        location={`${
          props.pagetype === 'vendor-list' ? 'vendor' : 'house'
        }-list-main`}
      />
    )
  }

  const mountPoint = document.querySelector('#SearchResultsPage')

  if (mountPoint) {
    const root = createRoot(mountPoint)
    root.render(
      <SearchResultsPage
        pagetype={mountPoint.dataset.pagetype}
        sherlock={window.SherlockContainer}
      />
    )
  }
})()
